import {Dialog, RadioGroup, styled} from "@mui/material";

export const EditOrderRecipientDialogContainer = styled(Dialog)(() => ({
    '& .MuiPaper-root': {
        maxWidth: '40rem',
        width: '100%',
    }
}));

export const EditRecipientContainer = styled('div')(() => ({
    display: 'flex',
    alignItems: 'flex-start',
    maxWidth: '40rem',
    width: '100%',
    height: 'fit-content',
    flexDirection: 'column',

    gap: '1rem',
    padding: '1rem 1.5rem',
    borderRadius: '0.5rem'
}));

export const RecipientSelectRadioGroup = styled(RadioGroup)(() => ({
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-evenly',
    width: '100%',

    '& .MuiFormControlLabel-root': {
        margin: 0
    }
}));